// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltips {
  position: relative;
  display: inline-block;
}

.member-view-box {
  text-align: center;
  border-radius: 2px;
  position: relative;
  max-width: 240px;
}

.member-image {
  position: relative;
  z-index: 10;
  width: 240px;
  border-radius: 4px;
}

.member-image img {
  height: 120px;
  background-color: #fff;
  width: 100%;
  object-fit: fill;
}

.member-image:hover .profile-container {
  display: inline-block;
}

.profile-container {
  /*display: none;*/
  position: absolute;
  right: 25px;
  top: -12px;
}

.profile-container img {
  border-radius: 4px;
  width: 34px;
  height: 34px;
  position: absolute;
}

.profile-container .profile-image {
  border-radius: 4px;
  width: 34px;
  height: 34px;
  position: absolute;
  font-size: 16px;
  cursor: pointer;
}

.profile-container-big {
  padding: 10px 0 5px 0;
}

.profile-container-big img {
  border-radius: 13px;
  width: 70px;
  height: 70px;
}

.no-video {
  background-color: #dfdfdf !important;
}

.svg-image {
  width: auto;
  margin: 0 auto;
  padding: 10px;
  background-color: #dfdfdf !important;
  border: 0px !important;
}

.child-name {
  color: black;
  margin: 0 auto;
  padding: 0 2px;
  /*white-space: initial;*/
  /*word-break: break-word;*/
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  line-height: 1.5;
}

.button-row {
  padding: 8px;
  text-align: center;
}

.button {
  background: transparent;
  /*background: #6c2fbb;*/
  /*border-radius: 8px;*/
  border: none;
  /*max-width: 96px;*/
  /*width: 100%;*/
  /*height: 40px;*/
  /*color: #ffffff;*/
  margin: auto 4px;
}

.button svg {
  fill: #663399FF;
}
`, "",{"version":3,"sources":["webpack://./src/app/layout/collab-single-video/collab-single-video.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,cAAc;EACd,wBAAwB;EACxB,0BAA0B;EAC1B,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".tooltips {\n  position: relative;\n  display: inline-block;\n}\n\n.member-view-box {\n  text-align: center;\n  border-radius: 2px;\n  position: relative;\n  max-width: 240px;\n}\n\n.member-image {\n  position: relative;\n  z-index: 10;\n  width: 240px;\n  border-radius: 4px;\n}\n\n.member-image img {\n  height: 120px;\n  background-color: #fff;\n  width: 100%;\n  object-fit: fill;\n}\n\n.member-image:hover .profile-container {\n  display: inline-block;\n}\n\n.profile-container {\n  /*display: none;*/\n  position: absolute;\n  right: 25px;\n  top: -12px;\n}\n\n.profile-container img {\n  border-radius: 4px;\n  width: 34px;\n  height: 34px;\n  position: absolute;\n}\n\n.profile-container .profile-image {\n  border-radius: 4px;\n  width: 34px;\n  height: 34px;\n  position: absolute;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n.profile-container-big {\n  padding: 10px 0 5px 0;\n}\n\n.profile-container-big img {\n  border-radius: 13px;\n  width: 70px;\n  height: 70px;\n}\n\n.no-video {\n  background-color: #dfdfdf !important;\n}\n\n.svg-image {\n  width: auto;\n  margin: 0 auto;\n  padding: 10px;\n  background-color: #dfdfdf !important;\n  border: 0px !important;\n}\n\n.child-name {\n  color: black;\n  margin: 0 auto;\n  padding: 0 2px;\n  /*white-space: initial;*/\n  /*word-break: break-word;*/\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n  line-height: 1.5;\n}\n\n.button-row {\n  padding: 8px;\n  text-align: center;\n}\n\n.button {\n  background: transparent;\n  /*background: #6c2fbb;*/\n  /*border-radius: 8px;*/\n  border: none;\n  /*max-width: 96px;*/\n  /*width: 100%;*/\n  /*height: 40px;*/\n  /*color: #ffffff;*/\n  margin: auto 4px;\n}\n\n.button svg {\n  fill: #663399FF;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
